export const YoutubeScreenIcon = () => {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 0H2C0.897 0 0 0.897 0 2V12C0 13.103 0.897 14 2 14H9V17H6V19H9H11H14V17H11V14H18C19.103 14 20 13.103 20 12V2C20 0.897 19.103 0 18 0ZM8 10V4L13 7L8 10Z"
        fill="#484848"
      />
    </svg>
  );
};
